import { styled } from '@mui/material/styles';
import React from 'react';

import Box from '@mui/material/Box';

import AppBar from './AppBar';
import Sidebar from './SideBar';

const drawerWidth = 250;

// necessary for content to be below app bar
export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

function Layout({ children }) {  
  return (
    <Box sx={{ display: 'flex', maxWidth: '100vw', maxHeight: '100vh' }}>
      <AppBar drawerWidth={drawerWidth} />
      <Sidebar drawerWidth={drawerWidth} />
      <Box sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: 0,
          width: 'calc(100vw - 310px)',
        }}
      >
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
}

export default Layout;
